import React from "react";
import Layout from "../layout/Layout";
import secondImage from "../assets/secondImage.png";

const About = () => {
  return (
    <Layout>
      <div className=" flex h-[92vh] px-10">
        {/* left content */}
        <div className=" lg:w-1/2 w-full mt-24 z-10 pb-10 overflow-y-auto max-h-[80vh] pr-4">
          <div className=" max-w-[80%]">
            <h1 className=" text-4xl font-bold text-[#3E3E3E]">
              We believe pets are family, and family deserves the best.
            </h1>
            
            <p className=" text-[#6D6D6D] text-[16px] mt-6 leading-relaxed">
              Founded by a group of passionate pet lovers, Cats & Dogs was born out of a simple mission: to make high-quality, handcrafted care accessible to every cat and dog. We believe that every tail wag, purr, and playful jump represents a bond worth protecting.
            </p>

            <p className=" text-[#6D6D6D] text-[16px] mt-4 leading-relaxed">
              We design and curate products that seamlessly integrate into your home, combining functional excellence with a warm, minimalist aesthetic. From nutritious diets to interactive play, we are committed to enriching the lives of pets and their parents alike.
            </p>

            <div className=" mt-10 grid grid-cols-2 gap-8 border-t border-[#F5D8CE] pt-8">
              <div>
                <h3 className=" text-xl font-bold text-[#3E3E3E]">Our Philosophy</h3>
                <p className=" text-[#6D6D6D] text-[14px] mt-2">
                  No compromises. We source only the finest materials and ingredients to keep your pets active and healthy.
                </p>
              </div>
              <div>
                <h3 className=" text-xl font-bold text-[#3E3E3E]">Our Community</h3>
                <p className=" text-[#6D6D6D] text-[14px] mt-2">
                  Building a supportive ecosystem of vet advice, local playgroups, and shared stories.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Pane (Static Image to support the white Navbar links) */}
        <div className=" lg:w-1/2 w-full h-full absolute top-0 right-0">
          <div
            className=" h-full"
            style={{
              backgroundImage: `url(${secondImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
        </div>
      </div>
    </Layout>
  );
};

export default About;